<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>{{ modalTitle }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <p class="text-danger text-center" v-if="hasError">{{ errorMessage }}</p>
        <d-form-row>
          <d-col>
            <c-input container-class="mb-3" label="Nom du rôle" placeholder="Ex: Marchand" v-model="name"
                     :state="nameState">
              Veuillez saisir un nom
            </c-input>
            <c-input container-class="mb-3" label="Slug" placeholder="Ex: MERCHANT" v-model="slug" :state="slugState">
              Veuillez saisir un slug
            </c-input>
            <c-input type="textarea" container-class="mb-3" label="Description" placeholder="Entrez une description..."
                     v-model="description"/>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4">
        <d-input-group class="justify-content-center">
          <d-button class="inline-btn" @click="modalVisible = true">
            <i class="fa fa-plus mr-1"></i> Ajouter un rôle
          </d-button>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="data" :fields="fields" :actions="actions" :per-page="10">
          <p class="text-center" slot="empty">Aucun rôle trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, Toast} from "@/helpers"

export default {
  title: "Paramètres des rôles",
  data() {
    return {
      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'name', label: 'Nom du rôle', sortable: true},
        {key: 'slug', label: 'Slug', sortable: true},
        {key: 'description', label: 'Description'},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {type: 'white', icon: 'fa fa-edit', title: "Modifier le rôle", handler: this.onItemSelect},
        {type: 'outline-danger', icon: 'fa fa-times', title: "Supprimer le rôle", handler: this.onItemRemove},
      ],

      modalVisible: false,

      selectedItem: null,

      name: '',
      slug: '',
      description: '',

      submitted: false,
      fetchingFormSubmit: false,
    }
  },
  computed: {
    itemSelected() {
      return !!this.selectedItem
    },
    modalTitle() {
      return this.itemSelected ? "Edition d'un rôle" : "Ajout d'un rôle"
    },
    nameState() {
      return !this.submitted || this.name.trim().length > 0
    },
    slugState() {
      return !this.submitted || this.slug.trim().length > 0
    },
  },
  created() {
    this.fetchingData = true
    Api.get('/role/list')
      .then(res => this.data = res.data.roles.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return item
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.name = item.name
      this.slug = item.slug
      this.description = item.description
      this.modalVisible = true
    },
    clearFields() {
      this.name = ''
      this.slug = ''
      this.description = ''
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.error = null
      this.clearFields()
    },
    isFormValid() {
      return this.nameState && this.slugState
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      const route = this.itemSelected ? '/role/update' : '/role/create'
      const extraData = this.itemSelected ? {role_id: this.selectedItem.id} : {}

      this.fetchingFormSubmit = true
      Api.postFormData(route, {
        name: this.name,
        slug: this.slug,
        description: this.description,
        ...extraData
      })
        .then(res => {
          const role = this.mapItem(res.data.role)
          const operation = this.itemSelected ? "mis à jour" : "créé"

          if (this.itemSelected)
            this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, role)
          else
            this.data.push(role)

          this.onModalClose()

          Toast.success(`Le rôle "${role.name}" a été ${operation} avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onItemRemove(item) {
      const ans = prompt(`Veuillez saisir SUPPRIMER pour supprimer le rôle "${item.name}".`)
      if (ans !== 'SUPPRIMER') return

      Toast.loading("Suppression du rôle...")
      Api.postFormData('/role/delete', {
        role_id: item.id
      })
        .then(res => {
          this.data = this.data.filter(_item => _item.id !== item.id)
          Toast.success(`Le rôle "${item.name}" a été supprimé avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    }
  }
}
</script>

<style scoped>

</style>
